export const SIK_CLIENT_NAME = "fixa";
export const SIK_API_VERSION = "20250507";
